import { Button, Stack } from "@mui/material";
import * as React from "react";
import Modal, { CommonModalProps } from "..";

import TitleData from "../../../Static/Data/title.json";
import ContentsTable from "../../Table/ContentsTable/contents-table";
import { useTranslation } from "react-i18next";

type CloseClbProps = {
  contents: any[];
};
export type ModalContentSelectionElementProps = {
  onClose?: (props: CloseClbProps) => void;
};

export type ModalContentSelectionProps = CommonModalProps<ModalContentSelectionElementProps>;

const ModalContentSelection = React.forwardRef<any, ModalContentSelectionProps>((_props, ref) => {
  const { closeModal, onClose } = _props;
  const { t } = useTranslation();

  const handleCancelClick: React.MouseEventHandler = () => {
    onClose && onClose({ contents: [] });
    closeModal();
  };

  const handleDoneClick: React.MouseEventHandler = () => {
    onClose && onClose({ contents: ["content1"] });
    closeModal();
  };

  return (
    <Modal
      title={t("modal:title.contentsSelection")}
      reference={ref}
      closeModal={closeModal}
      width={1024}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button variant="contained" onClick={handleDoneClick}>
            {t("button:startConfiguration")}
          </Button>
        </Stack>
      }
    >
      <ContentsTable rows={TitleData.contentDetails} hiddenColumns={["price"]} />
    </Modal>
  );
});

export default ModalContentSelection;
